import type {
  GetArtistInventoryItemPortfolioQueryVariables,
  GetArtistShopArtistInfoQueryVariables,
} from '@app/data/shop-bff';
import { useCallback, useState } from 'react';
import {
  ArtistInventoryItemPortfolio,
  ArtistShopArtistInfo,
} from 'types/shop-bff/types';
import { getCustomPublicShopBffSdk } from '../../../../utils/common';
import {
  ARTIST_INVENTORY_ITEM_PORTFOLIO_ENDPOINT,
  ARTIST_SHOP_ARTIST_INFO_ENDPOINT,
} from '../../../api/shop-bff/route-constants';

const artistInventoryShopSdk = getCustomPublicShopBffSdk(
  ARTIST_INVENTORY_ITEM_PORTFOLIO_ENDPOINT
);
const artistShopArtistInfoSdk = getCustomPublicShopBffSdk(
  ARTIST_SHOP_ARTIST_INFO_ENDPOINT
);

export const useArtistInventoryItemPortfolio = () => {
  const [{ artistInventory, loading }, setArtistInventory] = useState<{
    artistInventory: ArtistInventoryItemPortfolio | null;
    loading: boolean;
  }>({
    artistInventory: null,
    loading: true,
  });

  const refresh = useCallback(
    (variables: GetArtistInventoryItemPortfolioQueryVariables) => {
      setArtistInventory({ artistInventory: null, loading: true });

      artistInventoryShopSdk
        .GetArtistInventoryItemPortfolio(variables)
        .then((res) => {
          setArtistInventory({
            artistInventory: res.shop_artistInventoryItemPortfolio,
            loading: false,
          });
        })
        .catch(() => {
          // TODO: Handle errors
          setArtistInventory({
            artistInventory: null,
            loading: false,
          });
        });
    },
    []
  );

  return {
    artistInventory,
    loading,
    refresh,
  };
};

export const useArtistShopArtistInfo = () => {
  const [{ artistShopArtistInfo, loading }, setArtistShopArtistInfo] =
    useState<{
      artistShopArtistInfo: ArtistShopArtistInfo | null;
      loading: boolean;
    }>({
      artistShopArtistInfo: null,
      loading: true,
    });

  const refresh = useCallback(
    (variables: GetArtistShopArtistInfoQueryVariables) => {
      setArtistShopArtistInfo({ artistShopArtistInfo: null, loading: true });

      artistShopArtistInfoSdk
        .GetArtistShopArtistInfo(variables)
        .then((res) => {
          setArtistShopArtistInfo({
            artistShopArtistInfo: res.shop_artistShopArtistInfo,
            loading: false,
          });
        })
        .catch(() => {
          // TODO: Handle errors
          setArtistShopArtistInfo({
            artistShopArtistInfo: null,
            loading: false,
          });
        });
    },
    []
  );

  return {
    artistShopArtistInfo,
    loading,
    refresh,
  };
};
